import React, { Component, PropTypes } from 'react';
import './LoginForm.css';

import ProgressButton from './ProgressButton.js';

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: ''
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.formValid = this.formValid.bind(this);
  }

  handleInputChange(event) {
    const { target } = event;
    const { value, name } = target;

    // Update the state key of the input's `name` with the new value.
    this.setState({
      [name]: value
    });
  }

  handleSubmit(ev) {
    ev.preventDefault();
    this.props.onSubmit(this.state);
  }

  formValid() {
    return this.state.email && this.state.password;
  }

  render() {
    const { isSubmitting } = this.props;
    const formValid = this.formValid();

    let classes = ['form', 'LoginForm'];
    if (this.props.error) {
      classes.push('LoginForm--error');
    }

    return (
      <form className={classes.join(' ')} disabled={this.props.disabled} action="#" onSubmit={this.handleSubmit}>
        <div className="form-group">
          <input className="form-input form-input--dark form-input--fullwidth"
            name="email"
            type="email"
            placeholder="email"
            disabled={this.props.disabled}
            onChange={this.handleInputChange}
            value={this.state.email} />
        </div>

        <div className="form-group">
          <input className="form-input form-input--dark form-input--fullwidth"
            name="password"
            type="password"
            placeholder="password"
            disabled={this.props.disabled}
            onChange={this.handleInputChange}
            value={this.state.password} />
        </div>


        <ProgressButton type="submit"
          buttonStyle="dark"
          formSubmit={true}
          label="Log in"
          loadingLabel="Logging in..."
          loading={isSubmitting}
          disabled={!formValid || isSubmitting} />
      </form>
    );
  }
}

LoginForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool
}

export default LoginForm;



// WEBPACK FOOTER //
// ./src/components/LoginForm.js